/* eslint-disable react/no-danger */
import React, { useContext, useEffect, useState } from 'react';
import Fade from 'react-reveal/Fade';
import { Container, Row, Col } from 'react-bootstrap';
import Title from '../Title/Title';
import PortfolioContext from '../../context/context';
import ProjectImg from '../Image/ProjectImg';

const Experience = () => {
  const { projects } = useContext(PortfolioContext);

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="experience">
      <Container>
        <div className="project-wrapper">
          <Title title="Experience" />
          {projects.map((project) => {
            const { title, info, url, date, img, id, position, tech } = project;

            return (
              <Row key={id}>
                <Col lg={4} sm={12}>
                  <Fade
                    left={isDesktop}
                    bottom={isMobile}
                    duration={1000}
                    delay={500}
                    distance="30px"
                  >
                    <div className="project-wrapper__text">
                      <Row style={{ alignItems: 'center', marginBottom: '2rem' }}>
                        <ProjectImg
                          className="project-wrapper__text-jobLogo"
                          filename={img}
                          radius="100%"
                          size="8rem"
                          mr="1rem"
                        />
                        <Col>
                          <h4 className="project-wrapper__text-title">
                            {title || 'Project Title'}
                          </h4>
                          <p className="project-wrapper__text-subtitle">{position || 'loreem'}</p>
                        </Col>
                      </Row>
                      <div>
                        <p dangerouslySetInnerHTML={{ __html: info }} />
                        <p className="mb-4 date">{date}</p>
                      </div>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cta-btn cta-btn--hero"
                        href={url}
                      >
                        See Live
                      </a>
                    </div>
                  </Fade>
                </Col>
                <Col lg={8} sm={12}>
                  <Fade
                    right={isDesktop}
                    bottom={isMobile}
                    duration={1000}
                    delay={1000}
                    distance="30px"
                  >
                    <h4 className="project-wrapper__text-title" style={{ marginBottom: '2rem' }}>
                      Technologies
                    </h4>
                    <Col>
                      {tech.map((technology) => (
                        <Col className="tech-entry">
                          <p dangerouslySetInnerHTML={{ __html: technology }} />
                          <hr className="tech-entry__bottom-border" />
                        </Col>
                      ))}
                    </Col>
                  </Fade>
                </Col>
              </Row>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default Experience;
